// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"7ca323fa","517":"26c9daf2","787":"efcc1997"}[chunkId] + ".chunk.js";
};